import { render } from "./EndOfLife.vue?vue&type=template&id=67db4a35"
import script from "./EndOfLife.vue?vue&type=script&lang=js"
export * from "./EndOfLife.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__